import { render, staticRenderFns } from "./PackageHighlightsLayout.vue?vue&type=template&id=e43187d8"
import script from "./PackageHighlightsLayout.vue?vue&type=script&lang=js"
export * from "./PackageHighlightsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports